import React from 'react';

const Panorama = () => (
  <React.Fragment>
    <div className="panorama-cover">
      <div className="half left" />
      <div className="half right" />
    </div>
    <div id="panorama" />
  </React.Fragment>
);

export default Panorama;



// WEBPACK FOOTER //
// ./src/components/Studio/Panorama.js